import {
  BlockWrapper,
  defineBlock,
  useEditor,
} from "@smartfire/js-block-engine";
import mapboxgl from "mapbox-gl";
import { useState } from "react";
import style from "./block.module.scss";
import Header from "./header/index";
import Controller from "./controller/index";

const BiogentsStoreLocator = ({
  mapboxKey,
  geojson,
  countryCode,
  seasonColor,
  pluginBiogentsResellerActive,
}) => {
  const { isEditing } = useEditor();
  mapboxgl.accessToken = mapboxKey;

  const [selectedReseller, setSelectedReseller] = useState(null);
  const [map, setMap] = useState(null);
  const [resellerList, setResellerList] = useState([]);
  const [pendingCenter, setPendingCenter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <BlockWrapper.Div className={style.storeLocator}>
      {!isEditing ? (
        pluginBiogentsResellerActive ? (
          mapboxKey && geojson ? (
            <div className={style.storeLocatorContainer}>
              <Header
                map={map}
                resellerList={resellerList}
                selectedReseller={selectedReseller}
                setSelectedReseller={setSelectedReseller}
                setPendingCenter={setPendingCenter}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                countryCode={countryCode}
              />
              <Controller
                setMap={setMap}
                setResellerList={setResellerList}
                setSelectedReseller={setSelectedReseller}
                selectedReseller={selectedReseller}
                geojson={geojson}
                pendingCenter={pendingCenter}
                setPendingCenter={setPendingCenter}
                setIsLoading={setIsLoading}
                seasonColor={seasonColor}
              />
            </div>
          ) : (
            <div className={style.skeleton} />
          )
        ) : (
          <></>
        )
      ) : (
        <div className={style.isEditing}>
          <p>Store locator map will be here.</p>
          <p>
            Please activate "SBM - Biogents Reseller" and import your
            resellers to see the map on front.
          </p>
        </div>
      )}
    </BlockWrapper.Div>
  );
};

export default defineBlock({
  Block: BiogentsStoreLocator,
  smartProps: {},
  setup: {
    title: "Biogents Store locator",
  },
});
